import Vue from 'vue';
import router from './router';
import store from './store';
import App from './App';

import './fontawesome';

import '@/helpers/util';

import VuePhotoSwipe from './plugins/PhotoSwipe';
Vue.use(VuePhotoSwipe);

import VueLazyload from 'vue-lazyload';
Vue.use(VueLazyload, {
    throttleWait: 0,
    listenEvents: ['load', 'scroll', 'wheel', 'mousewheel', 'resize', 'animationend', 'transitionend', 'touchmove'],
    observer: true,
    observerOptions: {
        rootMargin: '0px',
        threshold: 0.1
    }
});

import VueTouchEvents from 'vue2-touch-events';
Vue.use(VueTouchEvents);

import VueProgressBar from 'vue-progressbar';
Vue.use(VueProgressBar, {
    color: '#000000',
    failedColor: '#e30018',
    // thickness: '5px',
    transition: {
        speed: '0.2s',
        opacity: '0.6s',
        termination: 100
    },
    position: 'absolute'
});

// import Sticky from 'vue-sticky-directive';
// Vue.use(Sticky);

import TreeMenu from '@/components/TreeMenu';
Vue.component('tree-menu', TreeMenu);

import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';
import PerfectScrollbar from 'vue2-perfect-scrollbar';
Vue.use(PerfectScrollbar);

import { apolloProvider } from './store/apollo';

import '@/init';
import '@/validation';
import '@/router/middleware';
import '@/filters';

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    apolloProvider,
    render: h => h(App)
}).$mount('#app');
